/**
 * Display-name + optional discriminator. The discriminator is set by the
 * server (`Lobby.toDetail` / `Lobby.toSummary`) only when there's a
 * same-name collision in the same lobby; otherwise it's `null` and we
 * render the plain name.
 *
 * Rendered as `Alice` in the normal case and `Alice#0042` (with the
 * suffix in a muted color) when there's a collision.
 */

export function Name({
  displayName,
  discriminator,
  className,
}: {
  displayName: string;
  discriminator?: string | null;
  className?: string;
}) {
  return (
    <span className={className}>
      {displayName}
      {discriminator && <span className="name-disc">#{discriminator}</span>}
    </span>
  );
}
